import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../../services/auth.service';
import { NotificationService } from '../../../services/notifications.service';
import { DEFAULT_ERROR, ERROR_MESSAGES, activeTranslations } from '../../../enum/constants';
import { IError } from '../../../interfaces';

@Component({
  selector: 'app-verifying-email',
  templateUrl: './verifying-email.component.html',
  styleUrl: './verifying-email.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VerifyingEmailComponent implements OnInit {
  public email: string;
  public sendingVerifyEmail: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly authService: AuthService,
    private readonly notificationService: NotificationService,
  ) {
    this.email = data.data.email;
  }

  ngOnInit() {
    this.resendVerifyEmail();
  }

  public resendVerifyEmail() {
    this.sendingVerifyEmail = true;
    this.authService.sendVerifyEmail(this.email).subscribe({
      next: () => {
        this.sendingVerifyEmail = false;
        this.notificationService.showSuccess(
          activeTranslations.notifications_texts.success.success,
          activeTranslations.notifications_texts.success.sent_verify_email,
        );
      },
      error: (e) => {
        this.sendingVerifyEmail = false;
        (e.error?.errors || []).forEach((err: IError) => {
          this.notificationService.showError(
            activeTranslations.notifications_texts.error.error,
            ERROR_MESSAGES[err.code] || ERROR_MESSAGES[DEFAULT_ERROR],
          );
        });
      },
    });
  }
}
